import { useRef } from 'react';
import { AlertDialog, AlertDialogButton, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/ResumePlanDialog';

TEXT.DEFINE({
  /** Details explaining what happens when account is reactivated */
  details:
    "You'll be able to view, comment, upload, and share again. Your previous subscription will resume immediately.",
  labels: {
    /** Cancel button label */
    cancel: 'Cancel',
    /** Confirm button label */
    confirm: 'Continue',
  },
  /** Dialog title */
  title: 'Reactivate Account?',
});

type Props = {
  isShowing: boolean;
  onRequestClose: VoidFunction;
  onConfirm: VoidFunction;
};

export const ResumePlanDialog = ({
  isShowing,
  onRequestClose,
  onConfirm,
}: Props) => {
  const title = TEXT.title;
  const details = TEXT.details;
  const cancelLabel = TEXT.labels.cancel;
  const confirmLabel = TEXT.labels.confirm;

  const focusRef = useRef(null);

  const handleConfirmation = () => {
    onConfirm();
    onRequestClose();
  };

  return (
    <AlertDialog
      actions={
        <>
          <AlertDialogButton ref={focusRef} onClick={onRequestClose}>
            {cancelLabel}
          </AlertDialogButton>

          <AlertDialogButton color="primary" onClick={handleConfirmation}>
            {confirmLabel}
          </AlertDialogButton>
        </>
      }
      aria-label={title}
      details={<Text variant="body">{details}</Text>}
      isShowing={isShowing}
      leastDestructiveRef={focusRef}
      title={title}
      variant="informative"
    />
  );
};
